import Versions from 'app/developer-v3/pages/versions';

export default {
  routes: {
    '.': Versions,
  },
};
